import React from 'react';
import { CurrencyRupeeIcon, CreditCardIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Card, Button } from 'components/ui';
import { hasPermission } from 'utils/permissionsUtils';

export const EmptyPaymentState = ({
  isMobile,
  isFeePayment = false,
  paidLinkExists,
  canCreatePaymentLink = true,
  paymentLinkBlockedReason = null,
  onCreatePaymentLink,
  isStudent = false,
}) => {
  return (
    <Card className={`${isMobile ? "p-4" : "p-8"} text-center`}>
      <div
        className={`${isMobile ? "h-12 w-12" : "h-16 w-16"} mx-auto mb-4 flex items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/20`}
      >
        <CurrencyRupeeIcon className={`${isMobile ? "h-6 w-6" : "h-8 w-8"} text-amber-600 dark:text-amber-400`} />
      </div>
      <h3
        className={`${isMobile ? "text-base" : "text-lg"} dark:text-dark-50 mb-2 font-semibold text-gray-900`}
      >
        {isFeePayment ? 'No fee payment links found' : 'No payment links found'}
      </h3>
      <p
        className={`${isMobile ? "text-sm" : "text-base"} dark:text-dark-300 text-gray-500 ${isMobile ? "mb-4" : "mb-6"}`}
      >
        {isFeePayment 
          ? 'No enrollment fee payment links have been created for this lead yet' 
          : 'No payment links have been created for this lead yet'}
      </p>

      {/* Warning message when previous steps are not completed */}
      {!canCreatePaymentLink && paymentLinkBlockedReason && (
        <div className="mb-4 flex items-center justify-center gap-2 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 px-4 py-3 text-sm text-amber-700 dark:text-amber-300">
          <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />
          <span>{paymentLinkBlockedReason}</span>
        </div>
      )}

      {hasPermission("MLLE") && !paidLinkExists && (
        <Button
          variant="soft"
          color={canCreatePaymentLink && !isStudent ? "primary" : "neutral"}
          className={`mx-auto flex items-center gap-2 ${isStudent ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onCreatePaymentLink}
          disabled={!canCreatePaymentLink || isStudent}
          title={isStudent ? "Cannot create payment link for student" : (!canCreatePaymentLink ? paymentLinkBlockedReason : undefined)}
        >
          <CreditCardIcon className="h-4 w-4" />
          <span>Create Payment Link</span>
        </Button>
      )}
    </Card>
  );
};
